// The tunnel's state as a pill: green up, blue waiting for the sign-in, orange down, gray none.
import { useT } from "../i18n";
import { Pill } from "../ui/status";
import type { Tone } from "../ui/tones";
import type { VpnState } from "./api";

const TONE: Record<VpnState, Tone> = { up: "green", signing_in: "blue", down: "orange", absent: "gray" };

export function VpnStatusPill({ state }: { state: VpnState }) {
  const t = useT().vpn.state;
  return <Pill tone={TONE[state]}>{t[state]}</Pill>;
}
